import React, { Component } from 'react'
import { Header, Button } from 'semantic-ui-react'

export default class Four0Eight extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <>
                <Header as={'h1'}>Network error</Header>
                <p>A network error prevented the page from loading. Please reload the page try again.</p>
                <p><Button primary onClick={ () => window.location.reload() }>Retry</Button></p>
            </>
        );
    }
}